import Header from "./class/Header";
import Floating from "./class/Floating";
import FirstviewVideo from "./class/FirstviewVideo";
import ContentsAnimation from "./class/ContentsAnimation";
import HowToUse from "./class/HowToUse";
import pageAnchor from "./class/pageAnchor";
import Accordion from "./class/Accordion";
import Tab from "./class/Tab";
import GuideSwiper from "./class/GuideSwiper";
import MatchHeight from "./class/MatchHeight";

import SmoothScroll from 'smooth-scroll';

export default class Main {
  constructor() {
      this.getId()
      this.init()

  }

  init() {
    new Header();
    new Floating();
    new ContentsAnimation();
    new pageAnchor();
    new MatchHeight();
  }

  getId() {
    let body_id = document.body.getAttribute('id')

    switch(body_id) {
      case 'top':
        new FirstviewVideo();
        new HowToUse();
        break;

      case 'faq':
        new Tab();
        new Accordion();
        break;

      case 'guide_01':
      case 'guide_02':
      case 'guide_03':
      case 'guide_04':
      case 'guide_05':
        new GuideSwiper();
        break;

      default:
    }

  }

}

window.addEventListener('DOMContentLoaded', () => {
  new Main()

  new SmoothScroll('a[href*="#"]',{
    // header: '[data-scroll-header]'
  })

})
